import { render, staticRenderFns } from "./MarketplaceReviewsTable.vue?vue&type=template&id=1c9ba03c&scoped=true"
import script from "./MarketplaceReviewsTable.vue?vue&type=script&lang=js"
export * from "./MarketplaceReviewsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ba03c",
  null
  
)

export default component.exports